import ajax from '@/utils/request'

// 设备总量 消息总量 金额
export const queryDeviceSummary = data => ajax('/api/dashboard/device/summary', data, 'GET')
// 消息趋势图
export const messageCountTrend = data => ajax('/api/dashboard/message/trendline', data, 'POST')
// 金额趋势图
export const moneyTrend = data => ajax('/api/statistics/dashboard/company/getReceivablesReport', data, 'POST')
// 设备量趋势图
export const deviceCountTrend = data => ajax('/api/dashboard/device/trendline', data, 'POST')
